<script setup lang="ts">
import monsterUrl from '/assets/monster/glad.png';
import SpeechBubble from '@/components/SpeechBubble.vue';
</script>

<template>
  <div class="container mx-auto py-8">
    <div class="flex justify-center flex-col items-center relative mx-auto">
      <div class="relative flex justify-center items-center">
        <speech-bubble
          color="purple"
          class="w-[200px] md:w-[220px]"
        />

        <div
          class="absolute lg:text-[15px] text-[min(5vw,1.15rem)] text-center w-[70%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          Nu tar vi några frågor om hur mycket du rör dig.
        </div>
      </div>
      <img class="monster shrink-0 -mt-4" :src="monsterUrl" />
    </div>
  </div>
</template>

<style scoped>
/* Add custom animations or transitions if needed */
.monster {
  transition: transform 0.3s ease;
}
.monster:hover {
  transform: scale(1.05);
}
</style>